import { AVAILABLE_LANGUAGES } from '@/constants';
import { SylndrHelpPoints } from './sylndr-help.types';
import Image from 'next/image';
import Typography from '@/components/shared/typography/typography.component';
import useTranslationHook from '@/hook/use-translation-client.hook';

export const SylndrHelpSectionModal = ({
    lang,
}: {
    lang: AVAILABLE_LANGUAGES;
}) => {
    const { t } = useTranslationHook();
    const reversedPoints = [...SylndrHelpPoints].reverse();
    return (
        <div className="bg-sky-50 -mx-4 pt-4 pb-5">
            <div className="mx-4">
                <div className="mb-3">
                    <Typography className="text-gray-800 text-body2SemiBold">
                        {t('CarProfile.SylndrHelp.title')}
                    </Typography>
                    <Typography className="text-gray-600 text-caption">
                        {t('CarProfile.SylndrHelp.subTitle')}
                    </Typography>
                </div>
                <div className="flex gap-x-2">
                    {reversedPoints.map(section => {
                        return (
                            <div
                                key={section.index}
                                className="flex flex-1 justify-between bg-white p-4 gap-x-3 rounded-xl"
                            >
                                <div className="flex items-center gap-3">
                                    <div className="flex-shrink-0">
                                        <Image
                                            src={section.miniIcon}
                                            alt={section.title.en}
                                            className="en:transform en:scale-x-[-1]"
                                        />
                                    </div>
                                    <div>
                                        <Typography className="text-captionSemiBold text-gray-800 mb-0.5">
                                            {section.title[lang]}
                                        </Typography>
                                        <Typography className="text-caption text-gray-500">
                                            {section.subTitle[lang]}
                                        </Typography>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
